import { oc } from '@orpc/contract';
import { tenantSchema } from '../schemas/tenant.schemas.js';
export const getCurrentTenantContract = oc
    .route({
    method: 'GET',
    path: '/tenant/current',
    tags: ['Tenant'],
    summary: "Return the signed-in session's tenant",
})
    .output(tenantSchema);
//# sourceMappingURL=get-current-tenant.contract.js.map